var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Folder",
    "data-name": "Controls/icon/Folder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2356",
    "data-name": "Rectangle 2356",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M47.716,23.647a1.526,1.526,0,0,0-1.182-.578h-2.9V19.155a1.507,1.507,0,0,0-1.508-1.505H25.743V16.5A1.507,1.507,0,0,0,24.235,15H13.543a1.507,1.507,0,0,0-1.508,1.5v26.99A1.507,1.507,0,0,0,13.543,45H42.032a.8.8,0,0,0,.169-.012c.024,0,.06-.012.084-.012A1.508,1.508,0,0,0,43.5,43.844l.133-.554,4.356-18.366A1.515,1.515,0,0,0,47.716,23.647ZM15.052,18.011h7.674v1.144a1.508,1.508,0,0,0,1.509,1.5H40.62v2.409H19.082a1.512,1.512,0,0,0-1.473,1.156L15.052,35ZM43.637,30.2l-2.8,11.79H16.488L20.264,26.08H44.615Z",
    transform: "translate(-11.035 -11)",
    fill: "#ffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmr);
export default __webpack_public_path__ + "static/media/emr.610fdddba3a629f9ee2a0664959346dc.svg";
export { ForwardRef as ReactComponent };